/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateFeedbackRequestViewModel } from "../types/CreateFeedbackRequestViewModel.ts";
import { eFeedbackTypeSchema } from "./eFeedbackTypeSchema.ts";

export const createFeedbackRequestViewModelSchema = z.object({
  title: z.string().nullish(),
  feedbackType: z.optional(
    z
      .lazy(() => eFeedbackTypeSchema)
      .describe("1 = Numeric | 2 = LikeAndDislike | 3 = LikeOnly | "),
  ),
  maxNumber: z.number().int().nullish(),
  allowMultipleAnswer: z.optional(z.boolean()),
  companyId: z.number().int().nullish(),
  isGlobal: z.optional(z.boolean()),
  showComment: z.optional(z.boolean()),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<CreateFeedbackRequestViewModel>;
